module.exports = __webpack_public_path__ + "static/media/13.1bc9b8e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/13.wav
// module id = 6rwP
// module chunks = 0